import { render, staticRenderFns } from "./CvItem.vue?vue&type=template&id=0a559fe1&"
import script from "./CvItem.vue?vue&type=script&lang=ts&"
export * from "./CvItem.vue?vue&type=script&lang=ts&"
import style0 from "./CvItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
